export default {
  new: 1,
  submited: 2,
  approved: 3,
  denied: 4,
};
